export const blockIconsSocialWorkspacePremiumNew = (
	<span className='material-symbols-outlined'>workspace_premium</span>
);
